module.exports = __webpack_public_path__ + "ci_vendor_aws_120_32.7e44.png";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/ci_vendor_aws_120_32.png
// module id = ./src/_asset/sources/assets/images/ci_vendor_aws_120_32.png
// module chunks = main